import React from 'react'
import ReactDOM from 'react-dom'
import AppProviders from './contexts'
import './styles/index.scss'
import { App } from './App'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <AppProviders>
    <App/>
  </AppProviders>,
  // eslint-disable-next-line no-undef
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
